<template>
<layout-content>
  <template #headerTitle>
    <h1 class="layout-content-header-text">{{$route.meta.label}}</h1>
    <div
      style="display:flex;gap:12px;float:left;margin-left:1em;"
      v-if="!centerDialogVisible"
    >
      <el-select v-model="query.dataType" size="small" style="width:130px;">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>

      <data-time-query :query="query" />

      <site-query :sites="filterSites" :query="query" />

      <el-button
        :disabled="canNotSearch"
        type="orange"
        size="small"
        icon="el-icon-search"
        @click="onSearchBtnClick()"
      >查询</el-button>
    </div>

    <div
      style="float:left;margin-left:1em;"
      v-if="centerDialogVisible"
    >
      <el-select v-model="uploadQuery.dataType" size="small" style="width:130px;" @change="dataTypeChange">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>

      <el-date-picker
        v-model="uploadQuery.beginTime"
        :picker-options="startDatePickerOptions"
        :clearable="false"
        :editable="false"
        placeholder="开始时间"
        type="datetime"
        :format="formatRule"
        :value-format="formatRule"
        size="small"
        style="width:200px;"
      />
      <span style="font-size:.7em;color:#606266"> ～ </span>
      <el-date-picker
        v-model="uploadQuery.endTime"
        :picker-options="endDatePickerOptions"
        :clearable="false"
        :editable="false"
        placeholder="结束时间"
        type="datetime"
        :format="formatRule"
        :value-format="formatRule"
        size="small"
        style="width:200px;"
      />

      <el-select v-model="uploadQuery.mn" placeholder="请选择站点" size="small" style="width:150px;">
        <el-option
          v-for="item in sites"
          :key="item.value"
          :label="item.name"
          :value="item.mn">
        </el-option>
      </el-select>

      <el-button
        :disabled="canNotSearch"
        type="orange"
        size="small"
        icon="el-icon-upload"
        @click="uploadData()"
      >补传</el-button>
    </div>
  </template>

  <template #toolbar>
    <el-radio-group v-model="centerDialogVisible" size="small">
      <el-radio-button :label="false">查询记录</el-radio-button>
      <el-radio-button :label="true">补传数据</el-radio-button>
    </el-radio-group>
    <!-- <el-button
      v-if="!centerDialogVisible"
      type="primary"
      size="small"
      @click="showDialog('查询记录')"
    >{{btnTitle}}</el-button>
    <el-button
      v-if="centerDialogVisible"
      type="primary"
      size="small"
      @click="showDialog('补传数据')"
    >{{btnTitle}}</el-button> -->
  </template>

  <template #body>
    <data-wrapper>
      <el-table
        ref="table"
        :data="list"
        height="100%"
        border
        highlight-current-row
        header-row-class-name="custom-table-header"
        class="custom-table"
        style="width:100%"
      >
        <el-table-column label="序号" width="50" align="center" fixed>
          <template v-slot="{$index}">{{$index + 1}}</template>
        </el-table-column>
        <el-table-column prop="siteName" label="站点" align="center" />
        <el-table-column prop="createTime" label="操作时间" align="center">
          <template v-slot="{row}">{{new Date(row.createTime).format('YYYY-MM-DD HH:mm:ss')}}</template>
        </el-table-column>
        <el-table-column prop="dataTypeName" label="操作类型" align="center" />
        <el-table-column prop="beginTime" label="补传范围" width="350" align="center">
          <template v-slot="{row}">{{new Date(row.beginTime).format('YYYY-MM-DD HH:mm:ss')}} ~ {{new Date(row.endTime).format('YYYY-MM-DD HH:mm:ss')}}</template>
        </el-table-column>
        <el-table-column prop="exeRtn" label="通讯状态" align="center">
          <template v-slot="{row}">{{row.exeRtn ? exeMsg[row.exeRtn]: '未知'}}</template>
        </el-table-column>
        <el-table-column prop="feedBackRes" label="操作结果" align="center" />
        <el-table-column prop="creatorName" label="操作人" align="center" />
      </el-table>
    </data-wrapper>
  </template>

  <template #footer>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[20, 50, 100, 200, 500]"
      :page-size="pageSize"
      :total="total"
      layout="total, sizes, prev, pager, next"
      background
      style="float:right;"
    >
    </el-pagination>
  </template>
</layout-content>
</template>

<script>
import BaseSiteData from '../../BaseSiteData'
import WebSocket from '../../../utils/WebSocket'
import WebSocketMessageOpt from '../../../utils/WebSocket/WebSocketMessageOpt'
import LayoutContent from '../../../components/Layout/Content'
import DataWrapper from '../../../components/Data/DataWrapper'
import {ajaxErrorHandlerMap} from '../../../utils/AjaxErrorHandler'

export default {
  name: 'OperationsDataResend',
  routeInfo: {
    label: '数据补传',
    icon: 'fa fa-eye'
  },
  extends: BaseSiteData,
  components: {DataWrapper, LayoutContent},
  data () {
    return {
      options: [{
        value: 1,
        label: '原始数据'
      }, {
        value: 5,
        label: '五分钟数据'
      }, {
        value: 60,
        label: '小时数据'
      }],
      dataTypeMap: {
        1: '原始数据',
        5: '五分钟数据',
        60: '小时数据'
      },
      feedBackResMap: {
        1: '反控失败!有未完成的反控进程',
        2: '发送失败,下位机未连接',
        3: '发送成功,等待连接确认通讯',
        4: '通讯超时,下位机未回复',
        5: '反控失败!下位机回复错误信息',
        6: '接收数据中,下位机已回复成功连接',
        7: '等待结束,通讯超时,下位机未回复结束通讯',
        8: '执行成功,反控结束',
        9: '执行成功,下位机没有数据'
      },
      exeMsg: {
        0: '等待接受请求',
        1: '请求被接受',
        2: '请求被拒绝',
        3: '密码错误',
        4: 'MN错误',
        5: 'ST错误',
        6: 'Flag错误',
        7: 'QN错误',
        8: 'CN错误',
        9: 'CRC校验错误',
        100: '未知错误'
      },
      qnMsg: {
        0: '等待执行',
        1: '执行成功',
        2: '执行失败，但不知道原因',
        3: '命令请求条件错误',
        4: '通讯超时',
        5: '系统繁忙不能执行',
        6: '系统故障',
        100: '没有数据'
      },
      centerDialogVisible: false,
      formatRule: 'yyyy-MM-dd HH:00:00',
      btnTitle: '补传数据',
      uploadQuery: {
        beginTime: '',
        endTime: '',
        dataType: 60,
        mn: ''
      },
      query: {
        dataType: 60,
        type: 5
      },
      dataList: [],
      dataListMap: {},
      currentPage: 1,
      total: 0,
      pageSize: 20,
      list: []
    }
  },
  computed: {
    endTimeDiff: () => 0,
    queryTimeStep: () => 3,
    startDatePickerOptions () {
      return {
        disabledDate: time => this.uploadQuery.endTime && time.getTime() > new Date(this.uploadQuery.endTime)
      }
    },
    endDatePickerOptions () {
      return {
        disabledDate: time => this.uploadQuery.beginTime && time.getTime() < new Date(this.uploadQuery.beginTime)
      }
    }
  },
  watch: {
    profileSites: {
      immediate: true,
      handler (newVal) {
        this.setSiteId(newVal)
      }
    }
  },
  methods: {
    setSiteId (sites) {
      if (sites.length === 0) {
        return
      }

      let {uploadQuery} = this

      if (!uploadQuery.mn) {
        uploadQuery.mn = sites[0].mn
      }
    },
    search () {
      this.getData()
    },
    getData () {
      this.changeLoadStatus(true)
      let {query} = this
      delete query.isAuditCompleted
      if (!query.beginTime || !query.beginTime || !query.siteIds || !query.dataType || !query.type) {
        this.dataList = []
        this.handleCurrentChange(1)
        this.changeLoadStatus(false)
      }
      this.$api.Anti.getControlLog(query).then(backData => {
        if (backData.length === 0) {
          this.dataList = []
          this.handleCurrentChange(1)
          return false
        }

        let {dataTypeMap, feedBackResMap, filterSiteMap} = this

        let temp = backData.map(item => {
          item.siteName = filterSiteMap[item.siteId].name
          item.dataTypeName = dataTypeMap[item.dataType]
          item.feedBackRes = feedBackResMap[item.feedback]

          return item
        })

        this.dataList = Object.freeze(temp.sort((x, y) => new Date(y.createTime).getTime() - new Date(x.createTime).getTime()))
        this.total = backData.length

        if (this.total > this.pageSize) {
          for (let index = 0; index < this.pageSize; index++) {
            this.list.push(backData[index])
          }
        } else {
          this.list = backData
        }

        this.handleCurrentChange(1)
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    currentChangePage (list, currentPage) {
      let from = (currentPage - 1) * this.pageSize
      let to = currentPage * this.pageSize
      this.list = []

      for (; from < to; from++) {
        if (list[from]) {
          this.list.push(list[from])
        }
      }
    },
    handleSizeChange (pageSize) {
      this.pageSize = pageSize
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange (currentPage) {
      this.currentPage = currentPage
      this.currentChangePage(this.dataList, currentPage)
    },
    dataTypeChange () {
      if (this.uploadQuery.dataType !== 60) {
        this.formatRule = 'yyyy-MM-dd HH:mm:00'
      } else {
        this.formatRule = 'yyyy-MM-dd HH:00:00'
      }
    },
    uploadData () {
      this.changeLoadStatus(true)
      let {uploadQuery, feedBackResMap} = this

      this.$api.Anti.getPullData(uploadQuery).then(backData => {
        let typeMap = {
          1: 'error',
          2: 'error',
          3: 'success'
        }
        this.$notify({
          title: '反馈',
          type: typeMap[backData.feedback],
          position: 'bottom-right',
          message: feedBackResMap[backData.feedback]
        })
        this.centerDialogVisible = false
      }).catch(console.error).finally(() => {
        setTimeout(() => {
          this.onSearchBtnClick()
          this.changeLoadStatus(false)
        }, 1500)
      })
    },
    showDialog (title) {
      this.btnTitle = title
      this.centerDialogVisible = !this.centerDialogVisible
    },
    onWebSocketReady (data) {
      let tableData = this.$refs.table.tableData

      let {dataTypeMap, feedBackResMap, filterSiteMap} = this

      data.siteName = filterSiteMap[data.siteId].name
      data.dataTypeName = dataTypeMap[data.dataType]
      data.feedBackRes = feedBackResMap[data.feedback]

      let tableDataMap = Object.values(tableData).reduce((map, item) => {
        map[item.id] = item

        return map
      }, {})

      if (Object.values(tableData).find(item => item.id === data.id)) {
        tableDataMap[data.id] = data

        this.dataList = Object.values(tableDataMap)
      }

      this.currentPage = 1
      this.currentChangePage(this.dataList, 1)
    },
    onSearchBtnClick () {
      this.search()
    }
  },
  mounted () {
    let {uploadQuery, userToken} = this
    let beginTime = new Date()
    beginTime.setDate(beginTime.getDate() - this.queryTimeStep)
    let endTime = new Date()
    endTime.setDate(endTime.getDate() - this.endTimeDiff)
    uploadQuery.beginTime = beginTime.format('YYYY-MM-DD 00:00:00')
    uploadQuery.endTime = endTime.format('YYYY-MM-DD 23:00:00')

    let websocket = this.websocket = new WebSocket(new WebSocketMessageOpt(ajaxErrorHandlerMap), process.env.WEB_SOCKET_PORT + process.env.WEB_SOCKET_HOST + process.env.WEB_SOCKET_PATH + '/' + userToken)
    websocket.on('pull_data', this.onWebSocketReady)
  },
  beforeDestroy () {
    let {websocket} = this
    websocket.close()
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/08Operations/03Data-Resend/index.vue